// extracted by mini-css-extract-plugin
module.exports = {"textSection":"BroadbandLabelContents_textSection__ZBSRg"};